export interface SchoolGeocoding {
    Id: string;
    DisplayName: string;
    Address: string;
    City: string;
    Zip: string;
    geocode?: { lat: number; lng: number };
}

export const schoolsGeocoding: SchoolGeocoding[] = [
    {
        Id: "5371",
        DisplayName: "C-Florida Cyber Charter Academy - 5371",
        Address: "9143 Phillips Hwy Ste 590",
        City: "Jacksonville",
        Zip: "32256",
        geocode: { lat: 30.2796728, lng: -81.6275566 }
    },
    {
        Id: "1261",
        DisplayName: "C-Somerset Academy Middle - 1261",
        Address: "1429 Broward RD",
        City: "Jacksonville",
        Zip: "32218-5315",
        geocode: { lat: 30.4180428, lng: -81.6633638 }
    },
    {
        Id: "5641",
        DisplayName: "C-River City Science Acad. Southeast - 5641",
        Address: "12397 Philips Hwy",
        City: "Jacksonville",
        Zip: "32256-1792",
        geocode: { lat: 30.1467255, lng: -81.521112 }
    },
    {
        Id: "2801",
        DisplayName: "Frank H Peterson Academies - 2801",
        Address: "7450 Wilson BLVD",
        City: "Jacksonville",
        Zip: "32210-3523",
        geocode: { lat: 30.2644715, lng: -81.7694968 }
    },
    {
        Id: "0331",
        DisplayName: "Riverside High School - 0331",
        Address: "1200 S McDuff Ave",
        City: "Jacksonville",
        Zip: "32205-8098",
        geocode: { lat: 30.3069588, lng: -81.7039866 }
    },
    {
        Id: "2021",
        DisplayName: "Reynolds Lane Elementary - 2021",
        Address: "840 Reynolds LN",
        City: "Jacksonville",
        Zip: "32254-2998",
        geocode: { lat: 30.3337002, lng: -81.7361695 }
    },
    {
        Id: "0871",
        DisplayName: "Englewood Elementary - 0871",
        Address: "4359 Spring Park RD",
        City: "Jacksonville",
        Zip: "32207-6957",
        geocode: { lat: 30.2782057, lng: -81.6166524 }
    },
    {
        Id: "0961",
        DisplayName: "Jean Ribault High School - 0961 ",
        Address: "3701 Winton Dr",
        City: "Jacksonville",
        Zip: "32208-2998",
        geocode: { lat: 30.3894598, lng: -81.7071408 }
    },
    {
        Id: "2491",
        DisplayName: "Greenland Pines Elem. - 2491",
        Address: "5050  GREENLAND RD",
        City: "JACKSONVILLE",
        Zip: "32258-1522",
        geocode: { lat: 30.1595321, lng: -81.5746618 }
    },
    {
        Id: "2591",
        DisplayName: "Mandarin Middle School - 2591",
        Address: "5100 Hood Rd",
        City: "Jacksonville",
        Zip: "32257-1122",
        geocode: { lat: 30.1891832, lng: -81.587761 }
    },
    {
        Id: "2331",
        DisplayName: "Lone Star Elementary - 2331",
        Address: "10400  Lone Star RD",
        City: "Jacksonville",
        Zip: "32225-6797",
        geocode: { lat: 30.3382667, lng: -81.5313976 }
    },
    {
        Id: "2551",
        DisplayName: "Enterprise Learning Acad. - 2551",
        Address: "8085 OLD MIDDLEBURG RD S",
        City: "JACKSONVILLE",
        Zip: "32222-1819",
        geocode: { lat: 30.1986372, lng: -81.8225001 }
    },
    {
        Id: "1241",
        DisplayName: "Northwestern Legends Elementary - 1241",
        Address: "2100 W 45th St",
        City: "Jacksonville",
        Zip: "32209-3099",
        geocode: { lat: 30.3716815, lng: -81.694853 }
    },
    {
        Id: "1601",
        DisplayName: "Waterleaf Elementary - 1601",
        Address: "450 Kernan Blvd N",
        City: "Jacksonville",
        Zip: "32225",
        geocode: { lat: 30.3334616, lng: -81.4896881 }
    },
    {
        Id: "1421",
        DisplayName: "Chaffee Trail Elementary - 1421",
        Address: "11400 SAM CARUSO WAY",
        City: "JACKSONVILLE",
        Zip: "32221-1830",
        geocode: { lat: 30.2790266, lng: -81.8523198 }
    },
    {
        Id: "2241",
        DisplayName: "Samuel Wolfson School of Advanced Studies - 2241",
        Address: "7000 Powers Ave",
        City: "Jacksonville",
        Zip: "32217-3398",
        geocode: { lat: 30.2499159, lng: -81.6157483 }
    },
    {
        Id: "2851",
        DisplayName: "A. Philip Randolph Career Academies - 2851",
        Address: "1157 Golfair BLVD",
        City: "Jacksonville",
        Zip: "32209-4037",
        geocode: { lat: 30.3700483, lng: -81.6767957 }
    },
    {
        Id: "2371",
        DisplayName: "Sandalwood High School - 2371",
        Address: "2750 John Prom Blvd",
        City: "Jacksonville",
        Zip: "32246-3999",
        geocode: { lat: 30.3008248, lng: -81.5171933 }
    },
    {
        Id: "2401",
        DisplayName: "Arlington Heights Elem. - 2401",
        Address: "1520 Sprinkle Dr",
        City: "Jacksonville",
        Zip: "32211-5452",
        geocode: { lat: 30.336628, lng: -81.5923578 }
    },
    {
        Id: "0781",
        DisplayName: "Biltmore Elementary - 0781",
        Address: "2101 W Palm Ave",
        City: "Jacksonville",
        Zip: "32254-1734",
        geocode: { lat: 30.349649, lng: -81.7282738 }
    },
    {
        Id: "1821",
        DisplayName: "Youth Development Center - 1821",
        Address: "3015 Parental Home Rd",
        City: "Jacksonville",
        Zip: "32216-5704",
        geocode: { lat: 30.2708199, lng: -81.5910405 }
    },
    {
        Id: "P360",
        DisplayName: "U - Jacksonville University - P360",
        Address: "2800  UNIVERSITY BLVD N",
        City: "JACKSONVILLE",
        Zip: "32211-",
        geocode: { lat: 30.350839, lng: -81.602518 }
    },
    {
        Id: "0161",
        DisplayName: "Ortega Elementary - 0161",
        Address: "4010 Baltic St",
        City: "Jacksonville",
        Zip: "32210-4300",
        geocode: { lat: 30.275214, lng: -81.70266 }
    },
    {
        Id: "2341",
        DisplayName: "Hidden Oaks Elementary School - 2341",
        Address: "6127 Cedar Hills Blvd",
        City: "Jacksonville",
        Zip: "32210-5199",
        geocode: { lat: 30.268422, lng: -81.7422698 }
    },
    {
        Id: "U973",
        DisplayName: "U - Florida State University - U973",
        Address: "4567  TALLAHASSEE RD",
        City: "JACKSONVILLE",
        Zip: "32216-6606",
        geocode: { lat: 30.389342, lng: -81.6814752 }
    },
    {
        Id: "2351",
        DisplayName: "Fort Caroline Elementary - 2351",
        Address: "3925  ATHORE DR",
        City: "JACKSONVILLE",
        Zip: "32277-2032",
        geocode: { lat: 30.3712151, lng: -81.5938749 }
    },
    {
        Id: "0301",
        DisplayName: "Loretto Elementary - 0301",
        Address: "3900  LORETTO RD",
        City: "Jacksonville",
        Zip: "32223-2098",
        geocode: { lat: 30.159362, lng: -81.607331 }
    },
    {
        Id: "1251",
        DisplayName: "C-Somerset Academy Elementary - 1251",
        Address: "2100 Dunn Ave",
        City: "Jacksonville",
        Zip: "32218",
        geocode: { lat: 30.438921, lng: -81.678906 }
    },
    {
        Id: "5511",
        DisplayName: "C-Duval Charter at Mandarin - 5511",
        Address: "5209 Shad Rd.",
        City: "JACKSONVILLE",
        Zip: "32257",
        geocode: { lat: 30.1939167, lng: -81.5800947 }
    },
    {
        Id: "5831",
        DisplayName: "C-Jacksonville Classical Academy - 5831",
        Address: "2043 Forest St.",
        City: "Jacksonville",
        Zip: "32204",
        geocode: { lat: 30.3250945, lng: -81.6833598 }
    },
    {
        Id: "1451",
        DisplayName: "Darnell Cookman - 1451",
        Address: "1701 N Davis ST",
        City: "Jacksonville",
        Zip: "32209-6518",
        geocode: { lat: 30.34547, lng: -81.666958 }
    },
    {
        Id: "0621",
        DisplayName: "Oceanway School - 0621",
        Address: "143 Oceanway Ave",
        City: "Jacksonville",
        Zip: "32218-2615",
        geocode: { lat: 30.466598, lng: -81.6295767 }
    },
    {
        Id: "0881",
        DisplayName: "John Stockton Elementary - 0881",
        Address: "4827 Carlisle Rd",
        City: "Jacksonville",
        Zip: "32210-8164",
        geocode: { lat: 30.259878, lng: -81.7044885 }
    },
    {
        Id: "5971",
        DisplayName: "C-Global Leadership Academy Intercoastal - 5971",
        Address: "13720 McCormick Rd.",
        City: "Jacksonville",
        Zip: "32225",
        geocode: { lat: 30.3593899, lng: -81.4832903 }
    },
    {
        Id: "0381",
        DisplayName: "Baldwin Middle-High Schl - 0381",
        Address: "291 Mill ST W",
        City: "Jacksonville",
        Zip: "32234-1307",
        geocode: { lat: 30.34024, lng: -81.72232 }
    },
    {
        Id: "2231",
        DisplayName: "Duncan U. Fletcher High - 2231",
        Address: "700 Seagate AVE",
        City: "Neptune Beach",
        Zip: "32266-3505",
        geocode: { lat: 30.3087644, lng: -81.4022323 }
    },
    {
        Id: "1761",
        DisplayName: "Pre-Trial Detention - 1761",
        Address: "500 E. Adams St",
        City: "Jacksonville",
        Zip: "32202",
        geocode: { lat: 30.3262109, lng: -81.6511085 }
    },
    {
        Id: "2741",
        DisplayName: "Westview K-8 - 2741",
        Address: "5270 Connie Jean Rd",
        City: "Jacksonville",
        Zip: "32210",
        geocode: { lat: 30.252674, lng: -81.8220349 }
    },
    {
        Id: "0711",
        DisplayName: "Hendricks Avenue Elem - 0711",
        Address: "3400  HENDRICKS AVE",
        City: "JACKSONVILLE",
        Zip: "32207-5384",
        geocode: { lat: 30.290423, lng: -81.648871 }
    },
    {
        Id: "8891",
        DisplayName: "X - Demo K - 8 - 8891",
        Address: "4037 Boulevard Center Dr.",
        City: "Jacksonville",
        Zip: "32207",
        geocode: { lat: 30.3008785, lng: -81.6192977 }
    },
    {
        Id: "0481",
        DisplayName: "Thomas Jefferson Elementary - 0481",
        Address: "8233 Nevada St",
        City: "Jacksonville",
        Zip: "32220-2651",
        geocode: { lat: 30.3256235, lng: -81.7867478 }
    },
    {
        Id: "0251",
        DisplayName: "Springfield Middle School - 0251",
        Address: "2034 Hubbard St.",
        City: "Jacksonville",
        Zip: "32206-3728",
        geocode: { lat: 30.3488546, lng: -81.6521723 }
    },
    {
        Id: "2111",
        DisplayName: "Southside Middle School - 2111",
        Address: "2948 Knights Ln E",
        City: "Jacksonville",
        Zip: "32216-5697",
        geocode: { lat: 30.2718208, lng: -81.595626 }
    },
    {
        Id: "5991",
        DisplayName: "C-Global Leadership Academy Arts - 5991",
        Address: "4660 Lusso Lane",
        City: "Jacksonville",
        Zip: "32246",
        geocode: { lat: 30.33218, lng: -81.65565 }
    },
    {
        Id: "5841",
        DisplayName: "C-River City Science Intracoastal - 5841 ",
        Address: "2002 San Pablo RD S",
        City: "Jacksonville",
        Zip: "32246",
        geocode: { lat: 30.3144447, lng: -81.449063 }
    },
    {
        Id: "2181",
        DisplayName: "San Mateo Elementary - 2181",
        Address: "600 Baisden Rd",
        City: "Jacksonville",
        Zip: "32218-4299",
        geocode: { lat: 30.439566, lng: -81.627847 }
    },
    {
        Id: "2481",
        DisplayName: "Edward White High School - 2481",
        Address: "1700 Old Middleburg RD N",
        City: "Jacksonville",
        Zip: "32210-1232",
        geocode: { lat: 30.2908347, lng: -81.7692709 }
    },
    {
        Id: "0281",
        DisplayName: "Oak Hill Academy - 0281",
        Address: "6910 Daughtry Boulevard S",
        City: "Jacksonville",
        Zip: "32210",
        geocode: { lat: 30.2524456, lng: -81.7606848 }
    },
    {
        Id: "1201",
        DisplayName: "C-River City Science Acad. - 1201",
        Address: "7565 Beach Blvd",
        City: "Jacksonville",
        Zip: "32216",
        geocode: { lat: 30.2889779, lng: -81.5794746 }
    },
    {
        Id: "1441",
        DisplayName: "Jacksonville Beach Elem. - 1441",
        Address: "315 10TH ST S",
        City: "Jacksonville Beach",
        Zip: "32250-3334",
        geocode: { lat: 30.283844, lng: -81.3985635 }
    },
    {
        Id: "2451",
        DisplayName: "Crown Point Elementary - 2451",
        Address: "3800  CROWN POINT RD",
        City: "JACKSONVILLE",
        Zip: "32257-6066",
        geocode: { lat: 30.1941327, lng: -81.6143603 }
    },
    {
        Id: "1411",
        DisplayName: "J. Allen Axson Elementary - 1411",
        Address: "4763 SUTTON PARK CT",
        City: "JACKSONVILLE",
        Zip: "32224-5289",
        geocode: { lat: 30.2554615, lng: -81.4603823 }
    },
    {
        Id: "1631",
        DisplayName: "Rufus E. Payne Elementary - 1631",
        Address: "6725 Hema Rd",
        City: "Jacksonville",
        Zip: "32209-1424",
        geocode: { lat: 30.3807034, lng: -81.7264163 }
    },
    {
        Id: "1591",
        DisplayName: "Pine Forest Elementary - 1591",
        Address: "3929 Grant Rd",
        City: "Jacksonville",
        Zip: "32207-6628",
        geocode: { lat: 30.2815567, lng: -81.6383452 }
    },
    {
        Id: "8881",
        DisplayName: "X - Demo High - 8881",
        Address: "4037 Boulevard Center Drive",
        City: "Jacksonville",
        Zip: "32207",
        geocode: { lat: 30.3008785, lng: -81.6192977 }
    },
    {
        Id: "2621",
        DisplayName: "Andrew A. Robinson Elem. - 2621",
        Address: "101 W 12th ST",
        City: "Jacksonville",
        Zip: "32206-3622",
        geocode: { lat: 30.350876, lng: -81.655453 }
    },
    {
        Id: "0261",
        DisplayName: "Pre-K Disabilities Center - 0261",
        Address: "4030 BOULEVARD CENTER DR",
        City: "JACKSONVILLE",
        Zip: "32207-2804",
        geocode: { lat: 30.3000389, lng: -81.6177334 }
    },
    {
        Id: "0141",
        DisplayName: "Grand Park Career Center - 0141",
        Address: "2335 W 18TH ST",
        City: "Jacksonville",
        Zip: "32209-4599",
        geocode: { lat: 30.3546277, lng: -81.700498 }
    },
    {
        Id: "2701",
        DisplayName: "Oceanway Elementary - 2701",
        Address: "12555  Gillespie Ave",
        City: "Jacksonville",
        Zip: "32218-3813",
        geocode: { lat: 30.4607011, lng: -81.6258379 }
    },
    {
        Id: "0321",
        DisplayName: "Marine Science Ed. Ctr. - 0321",
        Address: "1347 Palmer St",
        City: "Atlantic Beach",
        Zip: "32233-1347",
        geocode: { lat: 30.393596, lng: -81.4276734 }
    },
    {
        Id: "2671",
        DisplayName: "LaVilla Middle School - 2671",
        Address: "501 N Davis St",
        City: "Jacksonville",
        Zip: "32202-4728",
        geocode: { lat: 30.3322855, lng: -81.6672388 }
    },
    {
        Id: "5401",
        DisplayName: "C-Seaside Community School - 5401",
        Address: "10850 Old St Augustine RD",
        City: "Jacksonville",
        Zip: "32257",
        geocode: { lat: 30.1775954, lng: -81.6056779 }
    },
    {
        Id: "2091",
        DisplayName: "Holiday Hill Elementary - 2091",
        Address: "6900  ALTAMA RD",
        City: "JACKSONVILLE",
        Zip: "32216-9100",
        geocode: { lat: 30.3016434, lng: -81.5853673 }
    },
    {
        Id: "0971",
        DisplayName: "Cedar Hills Elementary - 0971",
        Address: "6534 Ish Brant Rd",
        City: "Jacksonville",
        Zip: "32210-7051",
        geocode: { lat: 30.258133, lng: -81.7504496 }
    },
    {
        Id: "0861",
        DisplayName: "Terry Parker High School - 0861",
        Address: "7301 Parker School Rd",
        City: "Jacksonville",
        Zip: "32211-5198",
        geocode: { lat: 30.3422307, lng: -81.5770257 }
    },
    {
        Id: "0661",
        DisplayName: "Alfred I. DuPont Middle School - 0661",
        Address: "2710 Dupont Ave",
        City: "Jacksonville",
        Zip: "32217-2635",
        geocode: { lat: 30.2507302, lng: -81.6326598 }
    },
    {
        Id: "2221",
        DisplayName: "Greenfield Elementary - 2221",
        Address: "6343 Knights LN N",
        City: "Jacksonville",
        Zip: "32216-5699",
        geocode: { lat: 30.2729869, lng: -81.5974922 }
    },
    {
        Id: "2561",
        DisplayName: "Landmark Middle School - 2561",
        Address: "101 Kernan Blvd N",
        City: "Jacksonville",
        Zip: "32225-5302",
        geocode: { lat: 30.332065, lng: -81.489457 }
    },
    {
        Id: "2791",
        DisplayName: "Kernan Middle School - 2791",
        Address: "2271 Kernan Blvd S",
        City: "Jacksonville",
        Zip: "32246-4073",
        geocode: { lat: 30.3049518, lng: -81.4858741 }
    },
    {
        Id: "1371",
        DisplayName: "C-Seacoast Charter Academy - 1371",
        Address: "9570 Regency Square Blvd.",
        City: "Jacksonville",
        Zip: "32225",
        geocode: { lat: 30.3261772, lng: -81.5479726 }
    },
    {
        Id: "0721",
        DisplayName: "Spring Park Elementary - 0721",
        Address: "2250 Spring Park Rd",
        City: "Jacksonville",
        Zip: "32207-3638",
        geocode: { lat: 30.3025547, lng: -81.6345535 }
    },
    {
        Id: "2261",
        DisplayName: "Crystal Springs Elem. - 2261",
        Address: "1200  Hammond BLVD",
        City: "Jacksonville",
        Zip: "32221-1439",
        geocode: { lat: 30.30204, lng: -81.798124 }
    },
    {
        Id: "2191",
        DisplayName: "Joseph Stilwell Middle School - 2191",
        Address: "7840 Burma Rd",
        City: "Jacksonville",
        Zip: "32221-6198",
        geocode: { lat: 30.3076311, lng: -81.7792023 }
    },
    {
        Id: "2321",
        DisplayName: "Chimney Lakes Elementary - 2321",
        Address: "9353 Staples Mill DR",
        City: "Jacksonville",
        Zip: "32244-6318",
        geocode: { lat: 30.1957125, lng: -81.8049775 }
    },
    {
        Id: "1311",
        DisplayName: "C-Duv Charter HS Baymeadows -1311",
        Address: "7510 Baymeadows Way",
        City: "Jacksonville",
        Zip: "32256",
        geocode: { lat: 30.2329282, lng: -81.586019 }
    },
    {
        Id: "N998",
        DisplayName: "Home Education Setting - N998",
        Address: "1701 PRUDENTIAL DR",
        City: "JACKSONVILLE",
        Zip: "32207-8182",
        geocode: { lat: 30.3164035, lng: -81.6552375 }
    },
    {
        Id: "2571",
        DisplayName: "Alimacani Elementary - 2571",
        Address: "2051 SAN PABLO RD S",
        City: "JACKSONVILLE",
        Zip: "32224-1031",
        geocode: { lat: 30.3142971, lng: -81.4469157 }
    },
    {
        Id: "2311",
        DisplayName: "Kernan Trail Elementary - 2311",
        Address: "2281  KERNAN BLVD S",
        City: "JACKSONVILLE",
        Zip: "32246-4073",
        geocode: { lat: 30.3048845, lng: -81.4818061 }
    },
    {
        Id: "2301",
        DisplayName: "Beauclerc Elementary - 2301",
        Address: "4555  CRAVEN RD W",
        City: "JACKSONVILLE",
        Zip: "32257-5003",
        geocode: { lat: 30.2174274, lng: -81.6030282 }
    },
    {
        Id: "1501",
        DisplayName: "New Berlin Elementary - 1501",
        Address: "3613 NEW BERLIN RD",
        City: "JACKSONVILLE",
        Zip: "32226-1837",
        geocode: { lat: 30.464457, lng: -81.5652351 }
    },
    {
        Id: "2521",
        DisplayName: "Alden Rd. Exc Student Ctr - 2521",
        Address: "11780 Alden RD",
        City: "Jacksonville",
        Zip: "32246-2499",
        geocode: { lat: 30.2999989, lng: -81.512704 }
    },
    {
        Id: "0121",
        DisplayName: "West Riverside Elementary - 0121",
        Address: "2801 Herschel St",
        City: "Jacksonville",
        Zip: "32205-8116",
        geocode: { lat: 30.3085739, lng: -81.6959502 }
    },
    {
        Id: "5421",
        DisplayName: "C-Biscayne High School - 5421",
        Address: "1680 Dunn Ave. Suite 8",
        City: "Jacksonville",
        Zip: "32218",
        geocode: { lat: 30.4318752, lng: -81.6741813 }
    },
    {
        Id: "9996",
        DisplayName: "Ps SWD - 9996",
        Address: "4037 BOULEVARD CENTER DR",
        City: "JACKSONVILLE",
        Zip: "32207",
        geocode: { lat: 30.3008785, lng: -81.6192977 }
    },
    {
        Id: "1581",
        DisplayName: "George W. Carver Elem. - 1581",
        Address: "2854 W 45th St",
        City: "Jacksonville",
        Zip: "32209-2825",
        geocode: { lat: 30.3688006, lng: -81.7110786 }
    },
    {
        Id: "1321",
        DisplayName: "C-Duval Charter at Baymeadows - 1321",
        Address: "7510 Baymeadows Way",
        City: "Jacksonville",
        Zip: "32256",
        geocode: { lat: 30.2329282, lng: -81.586019 }
    },
    {
        Id: "0311",
        DisplayName: "Julia Landon Middle School - 0311",
        Address: "1819 Thacker Ave",
        City: "Jacksonville",
        Zip: "32207-3397",
        geocode: { lat: 30.3074508, lng: -81.6532491 }
    },
    {
        Id: "0911",
        DisplayName: "Sallye B. Mathis Elementary - 0911",
        Address: "3501 Winton DR",
        City: "Jacksonville",
        Zip: "32208-6301",
        geocode: { lat: 30.3907698, lng: -81.7050899 }
    },
    {
        Id: "0061",
        DisplayName: "M. V. Rutherford Alt Ed Ctr - 0061",
        Address: "1514 Hubbard St",
        City: "Jacksonville",
        Zip: "32206-4536",
        geocode: { lat: 30.3420778, lng: -81.6533095 }
    },
    {
        Id: "0451",
        DisplayName: "Dinsmore Elementary - 0451",
        Address: "7126  CIVIC CLUB DR",
        City: "JACKSONVILLE",
        Zip: "32219-2004",
        geocode: { lat: 30.4258525, lng: -81.7666008 }
    },
    {
        Id: "2441",
        DisplayName: "Highlands Middle School - 2441",
        Address: "10913 Pine Estates Rd E",
        City: "Jacksonville",
        Zip: "32218-4698",
        geocode: { lat: 30.4339079, lng: -81.6828272 }
    },
    {
        Id: "2581",
        DisplayName: "Mandarin Oaks Elementary - 2581",
        Address: "10600 Hornets Nest RD",
        City: "JACKSONVILLE",
        Zip: "32257-1210",
        geocode: { lat: 30.1849955, lng: -81.5881305 }
    },
    {
        Id: "1691",
        DisplayName: "S. A. Hull Elementary - 1691",
        Address: "7528  Hull ST",
        City: "Jacksonville",
        Zip: "32219-3415",
        geocode: { lat: 30.3908995, lng: -81.7323138 }
    },
    {
        Id: "1401",
        DisplayName: "Chaffee Trail Middle School - 1401",
        Address: "11770 SAM CARUSO WAY",
        City: "JACKSONVILLE",
        Zip: "32221-1830",
        geocode: { lat: 30.2800203, lng: -81.8491822 }
    },
    {
        Id: "1611",
        DisplayName: "Bartram Springs Elementary - 1611",
        Address: "14799 BARTRAM SPRINGS PARKWAY",
        City: "JACKSONVILLE",
        Zip: "32258-6101",
        geocode: { lat: 30.108925, lng: -81.4952844 }
    },
    {
        Id: "2601",
        DisplayName: "Mandarin High School - 2601",
        Address: "4831 Greenland Rd",
        City: "Jacksonville",
        Zip: "32258-1517",
        geocode: { lat: 30.1644744, lng: -81.5851173 }
    },
    {
        Id: "0181",
        DisplayName: "Central Riverside Elem - 0181",
        Address: "2555  GILMORE ST",
        City: "JACKSONVILLE",
        Zip: "32204-3413",
        geocode: { lat: 30.3185908, lng: -81.6913877 }
    },
    {
        Id: "5901",
        DisplayName: "C-KIPP Jacksonville K-12 - 5901",
        Address: "1440 North McDuff Ave",
        City: "Jacksonville",
        Zip: "32254",
        geocode: { lat: 30.3423469, lng: -81.7068788 }
    },
    {
        Id: "0981",
        DisplayName: "Timucuan Elementary - 0981",
        Address: "5429  110th St",
        City: "Jacksonville",
        Zip: "32244-2199",
        geocode: { lat: 30.2411383, lng: -81.7232319 }
    },
    {
        Id: "1701",
        DisplayName: "Palm Ave. Exc. Student Ctr. - 1701",
        Address: "1301 W Palm Ave",
        City: "Jacksonville",
        Zip: "32254-2349",
        geocode: { lat: 30.3423258, lng: -81.7283537 }
    },
    {
        Id: "0701",
        DisplayName: "North Shore Elementary - 0701",
        Address: "5701 Silver PLZ",
        City: "Jacksonville",
        Zip: "32208-5299",
        geocode: { lat: 30.3751523, lng: -81.6557819 }
    },
    {
        Id: "2291",
        DisplayName: "Jacksonville Heights Elem - 2291",
        Address: "7750 Tempest ST S",
        City: "Jacksonville",
        Zip: "32244-1440",
        geocode: { lat: 30.2418095, lng: -81.7765746 }
    },
    {
        Id: "0491",
        DisplayName: "Duval Detention Center - 0491",
        Address: "1214 E 8TH ST",
        City: "Jacksonville",
        Zip: "32206-4006",
        geocode: { lat: 30.3452028, lng: -81.6385737 }
    },
    {
        Id: "0791",
        DisplayName: "Ramona Elementary - 0791",
        Address: "5540 Ramona BLVD",
        City: "Jacksonville",
        Zip: "32205-4752",
        geocode: { lat: 30.3122686, lng: -81.7427328 }
    },
    {
        Id: "1131",
        DisplayName: "C-Wayman Academy Of The Arts - 1131",
        Address: "1176 LaBelle St",
        City: "Jacksonville",
        Zip: "32205",
        geocode: { lat: 30.3035938, lng: -81.7319165 }
    },
    {
        Id: "2631",
        DisplayName: "Abess Park Elementary - 2631",
        Address: "12731  ABESS BLVD",
        City: "JACKSONVILLE",
        Zip: "32225-5942",
        geocode: { lat: 30.321736, lng: -81.476271 }
    },
    {
        Id: "0761",
        DisplayName: "Southside Estates Elementary - 0761",
        Address: "9775 Ivey Rd",
        City: "Jacksonville",
        Zip: "32246-3419",
        geocode: { lat: 30.3004094, lng: -81.5545098 }
    },
    {
        Id: "0734",
        DisplayName: "John Love Early Learning Center - 0734",
        Address: "1531 Winthrop St.",
        City: "Jacksonville",
        Zip: "32206",
        geocode: { lat: 30.3475413, lng: -81.6347257 }
    },
    {
        Id: "2211",
        DisplayName: "Normandy Village Elem. - 2211",
        Address: "8257 Herlong RD",
        City: "Jacksonville",
        Zip: "32210-2323",
        geocode: { lat: 30.284401, lng: -81.78717 }
    },
    {
        Id: "0581",
        DisplayName: "R. L. Brown Gifted and Talented Magnet - 0581",
        Address: "1535 Milnor Street",
        City: "Jacksonville",
        Zip: "32206",
        geocode: { lat: 30.3423172, lng: -81.6387236 }
    },
    {
        Id: "1061",
        DisplayName: "Long Branch Elementary - 1061",
        Address: "3723  Franklin ST",
        City: "Jacksonville",
        Zip: "32206-1599",
        geocode: { lat: 30.3617271, lng: -81.6381777 }
    },
    {
        Id: "1542",
        DisplayName: "John E. Ford K-8 School - 1542",
        Address: "1137 Cleveland St",
        City: "Jacksonville",
        Zip: "32209-6414",
        geocode: { lat: 30.3304331, lng: -81.6725892 }
    },
    {
        Id: "2641",
        DisplayName: "Chets Creek Elementary - 2641",
        Address: "13200 CHETS CREEK BLVD",
        City: "Jacksonville",
        Zip: "32224-5234",
        geocode: { lat: 30.2663781, lng: -81.4691285 }
    },
    {
        Id: "0171",
        DisplayName: "The Bridge to Success Academy Middle School - 0171",
        Address: "5443 Moncrief Rd",
        City: "Jacksonville",
        Zip: "32209",
        geocode: { lat: 30.3720633, lng: -81.6869728 }
    },
    {
        Id: "2081",
        DisplayName: "Parkwood Heights Elementary - 2081",
        Address: "1709 Lansdowne Dr",
        City: "Jacksonville",
        Zip: "32211-5197",
        geocode: { lat: 30.3401566, lng: -81.5731415 }
    },
    {
        Id: "0291",
        DisplayName: "The Bridge to Success Academy at West Jacksonville - 0291",
        Address: "9430 Lem Turner Road",
        City: "Jacksonville",
        Zip: "32208",
        geocode: { lat: 30.4113061, lng: -81.6895679 }
    },
    {
        Id: "0531",
        DisplayName: "C-Mycroschool Of Int Acad - 0531",
        Address: "1584 Normandy Village Pkwy, Ste 25",
        City: "Jacksonville",
        Zip: "32221",
        geocode: { lat: 30.2923127, lng: -81.7726741 }
    },
    {
        Id: "N999",
        DisplayName: "Out of State or PK-12 Private in State - N999",
        Address: "1701  PRUDENTIAL DR",
        City: "JACKSONVILLE",
        Zip: "32207-8182",
        geocode: { lat: 30.3164035, lng: -81.6552375 }
    },
    {
        Id: "1461",
        DisplayName: "Matthew W. Gilbert Middle School - 1461",
        Address: "1424 Franklin St",
        City: "Jacksonville",
        Zip: "32206-4899",
        geocode: { lat: 30.3607471, lng: -81.6391995 }
    },
    {
        Id: "1561",
        DisplayName: "Young Womens Leadership Academy (YWLA)/Young Mens Leadership Academy (YMLA)  at Eugene Butler- 1561",
        Address: "900 Acorn St",
        City: "Jacksonville",
        Zip: "32209",
        geocode: { lat: 30.337709, lng: -81.68526 }
    },
    {
        Id: "1981",
        DisplayName: "Teen Parent Service Ctr. - 1981",
        Address: "129 King St",
        City: "Jacksonville",
        Zip: "32204-2409",
        geocode: { lat: 30.3294936, lng: -81.6957837 }
    },
    {
        Id: "1811",
        DisplayName: "Hospital & Homebound - 1811",
        Address: "1128 Barber ST",
        City: "Jacksonville",
        Zip: "32209",
        geocode: { lat: 30.3393925, lng: -81.6884898 }
    },
    {
        Id: "1161",
        DisplayName: "Sadie T. Tillis Elementary - 1161",
        Address: "6084 Morse Ave",
        City: "Jacksonville",
        Zip: "32244-3730",
        geocode: { lat: 30.2261614, lng: -81.7391556 }
    },
    {
        Id: "2391",
        DisplayName: "Sabal Palm Elementary - 2391",
        Address: "1201 Kernan Blvd N",
        City: "Jacksonville",
        Zip: "32225-5005",
        geocode: { lat: 30.3442, lng: -81.489701 }
    },
    {
        Id: "1491",
        DisplayName: "Smart Pope Livingston Elementary - 1491",
        Address: "1128 Barber St",
        City: "Jacksonville",
        Zip: "32209-7199",
        geocode: { lat: 30.3393925, lng: -81.6884898 }
    },
    {
        Id: "DAY1",
        DisplayName: "Training - Instructional Technology School K-12",
        Address: "3047 Boulevard Center Drive",
        City: "Jacksonville",
        Zip: "32207",
        geocode: { lat: 30.2999955, lng: -81.6205018 }
    },
    {
        Id: "5441",
        DisplayName: "C-River City Sci. Acad. Innov. - 5441",
        Address: "8160 Baymeadows Way W",
        City: "Jacksonville",
        Zip: "32256",
        geocode: { lat: 30.2323426, lng: -81.589915 }
    },
    {
        Id: "7001",
        DisplayName: "Duval Virtual Inst Acad -7001",
        Address: "7000 Powers AVE",
        City: "Jacksonville",
        Zip: "32217-3398",
        geocode: { lat: 30.2499159, lng: -81.6157483 }
    },
    {
        Id: "0901",
        DisplayName: "Englewood High School - 0901",
        Address: "4412 Barnes RD",
        City: "Jacksonville",
        Zip: "32207-7469",
        geocode: { lat: 30.2782284, lng: -81.6099403 }
    },
    {
        Id: "5961",
        DisplayName: "C-Jacksonville Classical Academy East - 5961",
        Address: "5900 Fort Caroline Rd.",
        City: "Jacksonville",
        Zip: "32277",
        geocode: { lat: 30.3651327, lng: -81.5997129 }
    },
    {
        Id: "5381",
        DisplayName: "C-San Jose Preparatory - 5381",
        Address: "4072 Sunbeam Rd",
        City: "Jacksonville",
        Zip: "32257",
        geocode: { lat: 30.2046092, lng: -81.6101002 }
    },
    {
        Id: "7006",
        DisplayName: "Duval Virt Inst Acad Pt - 7006",
        Address: "7000 Powers AVE",
        City: "Jacksonville",
        Zip: "32217-3398",
        geocode: { lat: 30.2499159, lng: -81.6157483 }
    },
    {
        Id: "0201",
        DisplayName: "Fishweir Elementary - 0201",
        Address: "3977  HERSCHEL ST",
        City: "JACKSONVILLE",
        Zip: "32205-9267",
        geocode: { lat: 30.2918641, lng: -81.714129 }
    },
    {
        Id: "2271",
        DisplayName: "Mayport Elementary - 2271",
        Address: "2753  SHANGRILA DR",
        City: "ATLANTIC BEACH",
        Zip: "32233-2999",
        geocode: { lat: 30.3617463, lng: -81.4191343 }
    },
    {
        Id: "3900",
        DisplayName: "Empowerment Scholarship School - 3900",
        Address: "4037 Boulevard Center Dr.",
        City: "Jacksonville",
        Zip: "32207",
        geocode: { lat: 30.3008785, lng: -81.6192977 }
    },
    {
        Id: "0991",
        DisplayName: "Highlands Estates Academy - 0991",
        Address: "1000  DEPAUL DR",
        City: "JACKSONVILLE",
        Zip: "32218-5411",
        geocode: { lat: 30.4241322, lng: -81.6616589 }
    },
    {
        Id: "2421",
        DisplayName: "Louis S. Sheffield Elem. - 2421",
        Address: "13333 Lanier Rd",
        City: "Jacksonville",
        Zip: "32226-1799",
        geocode: { lat: 30.4777124, lng: -81.5879452 }
    },
    {
        Id: "0271",
        DisplayName: "GRASP Academy - 0271",
        Address: "3101 Justina Rd",
        City: "Jacksonville",
        Zip: "32277",
        geocode: { lat: 30.3559526, lng: -81.5996633 }
    },
    {
        Id: "2471",
        DisplayName: "Anchor Academy - 2471",
        Address: "555 Wonderwood Dr",
        City: "Atlantic Beach",
        Zip: "32233-4699",
        geocode: { lat: 30.3711539, lng: -81.4097357 }
    },
    {
        Id: "2171",
        DisplayName: "Don Brewer Elementary - 2171",
        Address: "3385  HARTSFIELD RD",
        City: "JACKSONVILLE",
        Zip: "32277-0917",
        geocode: { lat: 30.3602566, lng: -81.5580097 }
    },
    {
        Id: "7023",
        DisplayName: "Duval Virt Inst Acad Ft -7023",
        Address: "1701 Prudential Dr",
        City: "Jacksonville",
        Zip: "32217-3398",
        geocode: { lat: 30.3164035, lng: -81.6552375 }
    },
    {
        Id: "1531",
        DisplayName: "Stanton College Prep. - 1531",
        Address: "1149 W 13th St",
        City: "Jacksonville",
        Zip: "32209-5699",
        geocode: { lat: 30.3527258, lng: -81.6728948 }
    },
    {
        Id: "0391",
        DisplayName: "Gateway Comm. Services - 0391",
        Address: "3747 Belfort Rd",
        City: "Jacksonville",
        Zip: "32216-5813",
        geocode: { lat: 30.2591495, lng: -81.579098 }
    },
    {
        Id: "5631",
        DisplayName: "C-Seaside K-8 Charter School - 5631",
        Address: "2865 Mayport Rd.",
        City: "Atlantic Bch",
        Zip: "32233",
        geocode: { lat: 30.3534485, lng: -81.413648 }
    },
    {
        Id: "5711",
        DisplayName: "C-Seaside Charter North Campus - 5711",
        Address: "1429 Broward Rd",
        City: "Jacksonville",
        Zip: "32218",
        geocode: { lat: 30.4180428, lng: -81.6633638 }
    },
    {
        Id: "0651",
        DisplayName: "Atlantic Beach Elementary - 0651",
        Address: "298 SHERRY DR",
        City: "ATLANTIC BEACH",
        Zip: "32233-5238",
        geocode: { lat: 30.3274925, lng: -81.4008754 }
    },
    {
        Id: "0811",
        DisplayName: "Pace Center For Girls - 0811",
        Address: "2933  University Blvd N",
        City: "Jacksonville",
        Zip: "32211-3322",
        geocode: { lat: 30.3514495, lng: -81.6025223 }
    },
    {
        Id: "5411",
        DisplayName: "C-Duval Charter at Westside - 5411",
        Address: "9238 103rd St.",
        City: "Jacksonville",
        Zip: "32210",
        geocode: { lat: 30.2466556, lng: -81.8075217 }
    },
    {
        Id: "1641",
        DisplayName: "Mt. Herman Exc Student Ctr - 1641",
        Address: "1741 Francis St",
        City: "Jacksonville",
        Zip: "32209-6405",
        geocode: { lat: 30.3466548, lng: -81.6700361 }
    },
    {
        Id: "2381",
        DisplayName: "Fort Caroline Middle - 2381",
        Address: "3787 University Club Blvd",
        City: "Jacksonville",
        Zip: "32277-1973",
        geocode: { lat: 30.3691213, lng: -81.5957359 }
    },
    {
        Id: "2051",
        DisplayName: "Pickett Elementary - 2051",
        Address: "6305 Old Kings Rd",
        City: "Jacksonville",
        Zip: "32254-1198",
        geocode: { lat: 30.3723359, lng: -81.7466448 }
    },
    {
        Id: "0831",
        DisplayName: "San Jose Elementary - 0831",
        Address: "5805 Saint Augustine Rd",
        City: "Jacksonville",
        Zip: "32207-8088",
        geocode: { lat: 30.265431, lng: -81.6309333 }
    },
    {
        Id: "5551",
        DisplayName: "C-Duval Charter at Southside - 5551",
        Address: "8680 AC Skinner Pkwy",
        City: "Jacksonville",
        Zip: "32256",
        geocode: { lat: 30.2462271, lng: -81.5550622 }
    },
    {
        Id: "2541",
        DisplayName: "Mayport Coastal Sciences Middle School  - 2541",
        Address: "2600 Mayport Rd",
        City: "Atlantic Beach",
        Zip: "32233-2804",
        geocode: { lat: 30.3534485, lng: -81.413648 }
    },
    {
        Id: "APP",
        DisplayName: "Applicants",
        Address: "4037 Boulevard Center Dr Team Center B",
        City: "Jacksonville",
        Zip: "32207",
        geocode: { lat: 30.3008802, lng: -81.6193003 }
    },
    {
        Id: "2531",
        DisplayName: "Twin Lakes Academy Middle School - 2531",
        Address: "8050 Point Meadows Dr",
        City: "Jacksonville",
        Zip: "32256-7011",
        geocode: { lat: 30.222457, lng: -81.5157452 }
    },
    {
        Id: "2651",
        DisplayName: "First Coast High School - 2651",
        Address: "590 Duval Station RD",
        City: "Jacksonville",
        Zip: "32218-1869",
        geocode: { lat: 30.4820297, lng: -81.6075497 }
    },
    {
        Id: "1271",
        DisplayName: "C-KIPP V.O.I.C.E. Academy - 1271",
        Address: "1440 McDuff Ave. N.",
        City: "Jacksonville",
        Zip: "32254",
        geocode: { lat: 30.3423469, lng: -81.7068788 }
    },
    {
        Id: "0951",
        DisplayName: "Rutledge H. Pearson Elementary - 0951",
        Address: "4346  ROANOKE BLVD",
        City: "JACKSONVILLE",
        Zip: "32208-1160",
        geocode: { lat: 30.409922, lng: -81.7167583 }
    },
    {
        Id: "9995",
        DisplayName: " Ps Title I - 9995",
        Address: "1701 PRUDENTIAL DR",
        City: "JACKSONVILLE",
        Zip: "32207-8182",
        geocode: { lat: 30.3164035, lng: -81.6552375 }
    },
    {
        Id: "0681",
        DisplayName: "Venetia Elementary - 0681",
        Address: "4300 Timuquana Rd",
        City: "Jacksonville",
        Zip: "32210-8538",
        geocode: { lat: 30.2484103, lng: -81.7407611 }
    },
    {
        Id: "0461",
        DisplayName: "Arlington Elementary - 0461",
        Address: "1201 UNIVERSITY BLVD N",
        City: "JACKSONVILLE",
        Zip: "32211-8851",
        geocode: { lat: 30.332489, lng: -81.602963 }
    },
    {
        Id: "0751",
        DisplayName: "Paxon Advanced Studies - 0751",
        Address: "3239 Norman E Thagard Blvd",
        City: "Jacksonville",
        Zip: "32254-1796",
        geocode: { lat: 30.3454318, lng: -81.7249318 }
    },
    {
        Id: "0631",
        DisplayName: "Duncan U. Fletcher Middle School - 0631",
        Address: "2000 3rd St N",
        City: "Jacksonville Beach",
        Zip: "32250-7430",
        geocode: { lat: 30.30684, lng: -81.395609 }
    },
    {
        Id: "2411",
        DisplayName: "Westside High School - 2411",
        Address: "5530 Firestone Rd",
        City: "Jacksonville",
        Zip: "32244-1599",
        geocode: { lat: 30.2457446, lng: -81.7666613 }
    },
    {
        Id: "7004",
        DisplayName: "Duval Virt Inst Acad Fran - 7004",
        Address: "7000 Powers AVE",
        City: "Jacksonville",
        Zip: "32217-3398",
        geocode: { lat: 30.2499159, lng: -81.6157483 }
    },
    {
        Id: "0691",
        DisplayName: "Lake Shore Middle School - 0691",
        Address: "2519 Bayview Rd",
        City: "Jacksonville",
        Zip: "32210-5399",
        geocode: { lat: 30.2735158, lng: -81.7244182 }
    },
    {
        Id: "0841",
        DisplayName: "Bayview Elementary - 0841",
        Address: "3257 Lake Shore BLVD",
        City: "Jacksonville",
        Zip: "32210-5345",
        geocode: { lat: 30.2713355, lng: -81.7240427 }
    },
    {
        Id: "P145",
        DisplayName: "U - Embry-Riddle Aero Univ - P145",
        Address: "600 S. CLYDE MORRIS BLVD.",
        City: "JACKSONVILLE",
        Zip: "32114",
        geocode: undefined
    },
    {
        Id: "1291",
        DisplayName: "C-River City Science Elementary - 1291",
        Address: "7450 Beach Blvd",
        City: "Jacksonville",
        Zip: "32216",
        geocode: { lat: 30.2879763, lng: -81.5815976 }
    },
    {
        Id: "0191",
        DisplayName: "Ruth N. Upson Elementary - 0191",
        Address: "1090 Dancy St",
        City: "Jacksonville",
        Zip: "32205-5289",
        geocode: { lat: 30.3072086, lng: -81.7195161 }
    },
    {
        Id: "0931",
        DisplayName: "Pinedale Elementary - 0931",
        Address: "4228 Dignan ST",
        City: "JACKSONVILLE",
        Zip: "32254-4111",
        geocode: { lat: 30.3242945, lng: -81.7212368 }
    },
    {
        Id: "2691",
        DisplayName: "Biscayne Elementary - 2691",
        Address: "12230  BISCAYNE BLVD",
        City: "JACKSONVILLE",
        Zip: "32218-8616",
        geocode: { lat: 30.4519293, lng: -81.6696125 }
    },
    {
        Id: "5621",
        DisplayName: "C-Duval Charter at Coastal - 5621",
        Address: "12800 Beach Blvd.",
        City: "Jacksonville",
        Zip: "32246-4152",
        geocode: { lat: 30.2848309, lng: -81.4802372 }
    },
    {
        Id: "0821",
        DisplayName: "Love Grove Elementary - 0821",
        Address: "2446  University BLVD S",
        City: "Jacksonville",
        Zip: "32216-2547",
        geocode: { lat: 30.3019465, lng: -81.6019327 }
    },
    {
        Id: "2121",
        DisplayName: "Jean Ribault Middle School - 2121",
        Address: "3610 Ribault Scenic Dr",
        City: "Jacksonville",
        Zip: "32208-2997",
        geocode: { lat: 30.39239, lng: -81.712028 }
    },
    {
        Id: "1651",
        DisplayName: "William M. Raines High School - 1651",
        Address: "3663 Raines Ave",
        City: "Jacksonville",
        Zip: "32209-1999",
        geocode: { lat: 30.3821811, lng: -81.7096947 }
    },
    {
        Id: "0771",
        DisplayName: "Hyde Park Elementary - 0771",
        Address: "5300 Park St",
        City: "Jacksonville",
        Zip: "32205-7298",
        geocode: { lat: 30.2910209, lng: -81.736337 }
    },
    {
        Id: "1221",
        DisplayName: "C-Global Leadership Academy Discovery - 1221",
        Address: "8985 Lone Star Rd.",
        City: "Jacksonville",
        Zip: "32211",
        geocode: { lat: 30.3379778, lng: -81.5593476 }
    },
    {
        Id: "8871",
        DisplayName: "X - Demo Middle - 8871",
        Address: "4037 Boulevard Center Drive",
        City: "Jacksonville",
        Zip: "32207",
        geocode: { lat: 30.3008785, lng: -81.6192977 }
    },
    {
        Id: "2431",
        DisplayName: "Gregory Drive Elementary - 2431",
        Address: "7800 Gregory Dr",
        City: "Jacksonville",
        Zip: "32210-4685",
        geocode: { lat: 30.2606616, lng: -81.7771925 }
    },
    {
        Id: "2281",
        DisplayName: "Merrill Road Elementary - 2281",
        Address: "8239 Merrill Rd",
        City: "Jacksonville",
        Zip: "32277-2999",
        geocode: { lat: 30.3533223, lng: -81.5596606 }
    },
    {
        Id: "0801",
        DisplayName: "San Pablo Elementary - 0801",
        Address: "801 18th Ave N",
        City: "Jacksonville Beach",
        Zip: "32250-4898",
        geocode: { lat: 30.3058493, lng: -81.4007342 }
    },
    {
        Id: "0351",
        DisplayName: "Andrew Jackson High - 0351",
        Address: "3816 N Main St",
        City: "Jacksonville",
        Zip: "32206-1450",
        geocode: { lat: 30.3326185, lng: -81.6561 }
    },
    {
        Id: "0471",
        DisplayName: "C-Lone Star High School - 0471",
        Address: "8050-1 Lone Star Rd.",
        City: "Jacksonville",
        Zip: "32211",
        geocode: undefined
    },
    {
        Id: "0511",
        DisplayName: "Whitehouse Elementary - 0511",
        Address: "11160 General Ave",
        City: "Jacksonville",
        Zip: "32220-2118",
        geocode: { lat: 30.3111256, lng: -81.8465034 }
    },
    {
        Id: "0891",
        DisplayName: "Woodland Acres Elementary - 0891",
        Address: "328 Bowlan St N",
        City: "Jacksonville",
        Zip: "32211-9605",
        geocode: undefined
    },
    {
        Id: "8861",
        DisplayName: "X - Demo Elementary - 8861",
        Address: "4035 Boulevard Center Drive",
        City: "Jacksonville",
        Zip: "32207",
        geocode: { lat: 30.3008528, lng: -81.6193305 }
    },
    {
        Id: "5611",
        DisplayName: "C-Bridge Prep - 5611",
        Address: "6400 Atlantic Blvd",
        City: "Jacksonville",
        Zip: "32211",
        geocode: { lat: 30.3125002, lng: -81.5932571 }
    },
    {
        Id: "2681",
        DisplayName: "Atlantic Coast High - 2681",
        Address: "9735 R.G. Skinner Parkway",
        City: "Jacksonville",
        Zip: "32256-3979",
        geocode: { lat: 30.2027996, lng: -81.5063458 }
    },
    {
        Id: "2141",
        DisplayName: "Hyde Grove Elementary - 2141",
        Address: "2056 Lane Ave S",
        City: "Jacksonville",
        Zip: "32210-2797",
        geocode: { lat: 30.2802468, lng: -81.7563009 }
    },
    {
        Id: "2511",
        DisplayName: "Twin Lakes Elementary - 2511",
        Address: "8000 Point Meadows Dr",
        City: "Jacksonville",
        Zip: "32256-7011",
        geocode: { lat: 30.223124, lng: -81.5181945 }
    },
    {
        Id: "2461",
        DisplayName: "Neptune Beach Elementary - 2461",
        Address: "1515  FLORIDA BLVD",
        City: "NEPTUNE BEACH",
        Zip: "32266-3121",
        geocode: { lat: 30.3162744, lng: -81.4138766 }
    },
    {
        Id: "1521",
        DisplayName: "James Weldon Johnson Middle School - 1521",
        Address: "3276 Norman Thagard Blvd",
        City: "Jacksonville",
        Zip: "32254-1765",
        geocode: undefined
    },
    {
        Id: "2131",
        DisplayName: "Arlington Middle School - 2131",
        Address: "8141 Lone Star Rd",
        City: "Jacksonville",
        Zip: "32211-5145",
        geocode: { lat: 30.3377282, lng: -81.5703995 }
    },
    {
        Id: "1211",
        DisplayName: "C-Tiger Academy Elementary - 1211",
        Address: "6079 Bagley  Rd.",
        City: "Jacksonville",
        Zip: "32209",
        geocode: { lat: 30.3741459, lng: -81.7191276 }
    },
    {
        Id: "1231",
        DisplayName: "C-Duval Charter Scholars Academy - 1231",
        Address: "100 Scholars Way",
        City: "Jacksonville",
        Zip: "32216",
        geocode: undefined
    },
    {
        Id: "0591",
        DisplayName: "Garden City Elementary - 0591",
        Address: "2814 Dunn AVE",
        City: "Jacksonville",
        Zip: "32218-4661",
        geocode: { lat: 30.4386807, lng: -81.6932397 }
    },
    {
        Id: "2361",
        DisplayName: "Mamie Agnes Jones Elementary - 2361",
        Address: "700  ORANGE AVE",
        City: "Jacksonville",
        Zip: "32234-1000",
        geocode: { lat: 30.3241447, lng: -81.6100216 }
    },
    {
        Id: "2072",
        DisplayName: "Westside Middle School - 2072",
        Address: "4815 Wesconnett Blvd",
        City: "Jacksonville",
        Zip: "32210-7398",
        geocode: { lat: 30.2553897, lng: -81.7370818 }
    },
    {
        Id: "0851",
        DisplayName: "Lake Lucina Elementary - 0851",
        Address: "6527  MERRILL RD",
        City: "JACKSONVILLE",
        Zip: "32277-3626",
        geocode: { lat: 30.3519432, lng: -81.5891243 }
    },
    {
        Id: "5981",
        DisplayName: "C-KIPP Impact Academy - 5981",
        Address: "7000 103rd Street ",
        City: "Jacksonville",
        Zip: "32210",
        geocode: { lat: 30.248261, lng: -81.760317 }
    },
    {
        Id: "1021",
        DisplayName: "C-School of Success Academy - 1021",
        Address: "6974  Wilson Blvd.",
        City: "Jacksonville",
        Zip: "32210",
        geocode: { lat: 30.26992, lng: -81.7597294 }
    },
    {
        Id: "C907",
        DisplayName: "U - Florida Comm Coll - Jax - C907",
        Address: "101 W STATE ST",
        City: "JACKSONVILLE",
        Zip: "32202-3089",
        geocode: { lat: 30.3353821, lng: -81.6598334 }
    },
    {
        Id: "1073",
        DisplayName: "Douglas Anderson Sch Arts - 1073",
        Address: "2445 San Diego RD",
        City: "Jacksonville",
        Zip: "32207-3630",
        geocode: { lat: 30.299964, lng: -81.6390183 }
    },
    {
        Id: "5601",
        DisplayName: "C-River City Science Academy at Mandarin - 5601",
        Address: "10911 Old St Augustine Rd.",
        City: "Jacksonville",
        Zip: "32257",
        geocode: { lat: 30.1769482, lng: -81.6041011 }
    },
    {
        Id: "2061",
        DisplayName: "Brookview Elementary - 2061",
        Address: "10450 Theresa DR",
        City: "Jacksonville",
        Zip: "32246-8746",
        geocode: { lat: 30.3196704, lng: -81.5285581 }
    },
    {
        Id: "0641",
        DisplayName: "Hogan-Spring Glen Elem - 0641",
        Address: "6736 Beach BLVD",
        City: "Jacksonville",
        Zip: "32216-2881",
        geocode: { lat: 30.2877142, lng: -81.590275 }
    },
    {
        Id: "2251",
        DisplayName: "Seabreeze Elementary - 2251",
        Address: "1400  Seabreeze Ave",
        City: "Jacksonville Beach",
        Zip: "32250-3293",
        geocode: { lat: 30.2705743, lng: -81.4000598 }
    },
    {
        Id: "5591",
        DisplayName: "C-Duval Charter at Flagler Center - 5591",
        Address: "12755 Flagler Center Blvd",
        City: "Jacksonville",
        Zip: "32258-2610",
        geocode: { lat: 30.1386033, lng: -81.5169274 }
    }
];